<div class="contenedor__action">
    <mat-dialog-actions>
        <button matDialogClose class="boton-dialog">X</button>
    </mat-dialog-actions>
</div>

<mat-dialog-content class="contenido">
    <ng-content select="[body]"></ng-content>
</mat-dialog-content>
